import axios from 'axios';

export default {
  namespaced: true,
  state: {
    consent: {},
    hasError: false,
    errorMessage: '',
    submitSuccess: false,
  },
  mutations: {
    setConsent(state, data) {
      state.consent = data;
    },
    setError(state, data) {
      state.hasError = true;
      state.errorMessage = data;
    },
    resetError(state) {
      state.hasError = false;
      state.errorMessage = '';
    },
    setSubmitSuccess(state, value) {
      state.submitSuccess = value;
    },
  },
  actions: {
    async submitConsent({ commit }, payload) {
      try {
        await axios.post(`${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/consent`, payload);
        commit('setSubmitSuccess', true);
      } catch(e) {
        commit('setError', e.message);
      }
    },
    async getConsent({ commit }, contactId) {
      try {
        const resp = await axios.get(`${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/contact/${contactId}/consent`);
        if (resp.data && resp.data.code === 404) {
          commit('setConsent', {});
          return
        }
        commit('setConsent', resp.data);
      } catch(e) {
        commit('setError', e.message);
        commit('setConsent', {});
      }
    },
  },
}
